import React from "react";
import { Table, Pagination } from 'react-bootstrap';

const Qna = () => {
    return (

        <div className="qna">
            <Table striped>
                <thead>
                    <tr>
                        <th>답변여부</th>
                        <th>문의 내용</th>
                        <th>작성자</th>
                        <th>작성일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>답변대기</td>
                        <td>사이즈 문의드립니다</td>
                        <td>mary</td>
                        <td>2023-03-15</td>
                    </tr>
                    <tr>
                        <td>답변완료</td>
                        <td>재입고 언제 되나요!</td>
                        <td>jake</td>
                        <td>2023-03-13</td>
                    </tr>
                    <tr>
                        <td>답변완료</td>
                        <td>환불 신청</td>
                        <td>harry</td>
                        <td>2023-03-13</td>
                    </tr>
                    <tr>
                        <td>답변완료</td>
                        <td>배송 오늘 출발 가능 한가요?</td>
                        <td>tom</td>
                        <td>2023-03-12</td>
                    </tr>
                    <tr>
                        <td>답변완료</td>
                        <td>사이즈 교환</td>
                        <td>john</td>
                        <td>2023-03-11</td>
                    </tr>
                </tbody>
            </Table>

            <Pagination>
                <Pagination.First />
                <Pagination.Prev />
                <Pagination.Item  active>{1}</Pagination.Item>
                <Pagination.Item>{2}</Pagination.Item>
                <Pagination.Item>{3}</Pagination.Item>
                <Pagination.Item>{4}</Pagination.Item>
                <Pagination.Item>{5}</Pagination.Item>
                <Pagination.Next />
                <Pagination.Last />
            </Pagination>
        </div>
    )
}

export default Qna;